// =============================================================================
// supplier-monitoring-client.http.ts — Adaptateur HTTP RÉEL du SupplierMonitoringClient.
// =============================================================================
// V-SUIVI-FOURN-read (PFP-2026-07-21-002). Câble la Section « Suivi fournisseurs » derrière le MÊME DI seam
// (SupplierMonitoringClientProvider) : l'écran consomme l'interface, l'impl est substituée sans toucher l'UI.
//
// AUTORITÉ = API (NestJS, AdminSessionGuard, withAdmin, composition EN MÉMOIRE via ports ACL). Cet adaptateur
// ne porte AUCUNE règle métier : GET (admin LIT, jamais d'écriture — invariant n°1), parse, mappe l'erreur.
// SÉCURITÉ : session admin = COOKIE httpOnly (credentials: 'include') ; GET ⇒ aucun en-tête CSRF requis.

import {
  SupplierMonitoringApiError,
  type CampaignSupplierMonitoringDto,
  type SupplierMonitoringClient,
} from '@/api/supplier-monitoring-client';

/** Forme attendue d'un corps d'erreur structuré (NestJS HttpException). */
interface StructuredErrorBody {
  readonly statusCode?: number;
  readonly message?: string;
}

export class HttpSupplierMonitoringClient implements SupplierMonitoringClient {
  public constructor(private readonly baseUrl: string = '/api') {}

  public async getSupplierMonitoring(
    campaignId: string,
  ): Promise<CampaignSupplierMonitoringDto> {
    const response = await fetch(
      `${this.baseUrl}/admin/campaigns/${encodeURIComponent(campaignId)}/supplier-monitoring`,
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'content-type': 'application/json' },
      },
    );
    if (!response.ok) {
      throw await this.toApiError(response);
    }
    return (await response.json()) as CampaignSupplierMonitoringDto;
  }

  /** Convertit une réponse non-OK en erreur applicative typée (message serveur tel quel + statut). */
  private async toApiError(response: Response): Promise<SupplierMonitoringApiError> {
    let body: StructuredErrorBody | undefined;
    try {
      body = (await response.json()) as StructuredErrorBody;
    } catch {
      body = undefined;
    }
    const message =
      body?.message ??
      `Erreur API (${String(response.status)}) sur le suivi fournisseurs.`;
    return new SupplierMonitoringApiError(message, response.status);
  }
}
